import {
  SITE_CONTACT_EMAIL,
  SITE_SUPPORT_WHATSAPP_DISPLAY,
  SITE_SUPPORT_WHATSAPP_E164,
} from "@/lib/site-contact"
import { e164ToWhatsAppRecipient } from "@/lib/whatsapp/phone-e164"

export type SupportWhatsAppUserContext = {
  id?: string | null
  name?: string | null
  email?: string | null
}

export function buildSupportWhatsAppUrl(options?: {
  text?: string
  phoneE164?: string
}): string {
  const phone = e164ToWhatsAppRecipient(options?.phoneE164 ?? SITE_SUPPORT_WHATSAPP_E164)
  const base = `https://wa.me/${phone}`
  const text = options?.text?.trim()
  if (!text) return base
  return `${base}?text=${encodeURIComponent(text)}`
}

export function buildPublicSupportWhatsAppMessage(): string {
  return "Olá! Gostaria de falar com a Astra Energia."
}

export function buildPanelSupportWhatsAppMessage(user?: SupportWhatsAppUserContext): string {
  const lines = ["Olá! Sou cliente Astra Energia e preciso de ajuda."]
  if (user?.name?.trim()) {
    lines.push(`Nome: ${user.name.trim()}`)
  }
  if (user?.email?.trim()) {
    lines.push(`E-mail: ${user.email.trim()}`)
  }
  if (user?.id?.trim()) {
    lines.push(`ID do cadastro: ${user.id.trim()}`)
  }
  return lines.join("\n")
}

export function getSupportWhatsAppDisplayPhone(): string {
  return SITE_SUPPORT_WHATSAPP_DISPLAY
}

export function getSupportContactEmail(): string {
  return SITE_CONTACT_EMAIL
}
